import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const ContactIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 22 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        className="tenera-icon"
        {...props}
    >
        <path
            d="M11.5133 12.1183C13.2622 12.1183 14.68 10.7149 14.68 8.98383C14.68 7.25271 13.2622 5.84937 11.5133 5.84937C9.76434 5.84937 8.34656 7.25271 8.34656 8.98383C8.34656 10.7149 9.76434 12.1183 11.5133 12.1183Z"
            fill="currentColor"
            className="accent"
        />
        <path
            d="M16.6663 19.0529H6.36008C6.12848 17.1352 8.48458 14.0272 11.4999 13.9611H11.5266C14.5463 14.0272 16.8979 17.1352 16.6663 19.0529Z"
            fill="currentColor"
            className="accent"
        />
        <path
            d="M18.8399 1.44086H3.7947C2.84767 1.44086 2.07996 2.20076 2.07996 3.13814V22.8619C2.07996 23.7993 2.84767 24.5592 3.7947 24.5592H18.8399C19.7869 24.5592 20.5546 23.7993 20.5546 22.8619V3.13814C20.5546 2.20076 19.7869 1.44086 18.8399 1.44086Z"
            stroke="currentColor"
            className="primary"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.74125 7.96985H0.41421C0.185448 7.96985 0 8.15242 0 8.37764C0 8.60285 0.185448 8.78543 0.41421 8.78543H3.74125C3.97001 8.78543 4.15546 8.60285 4.15546 8.37764C4.15546 8.15242 3.97001 7.96985 3.74125 7.96985Z"
            fill="currentColor"
            className="primary"
        />
        <path
            d="M3.74125 12.5944H0.41421C0.185448 12.5944 0 12.7769 0 13.0021C0 13.2274 0.185448 13.4099 0.41421 13.4099H3.74125C3.97001 13.4099 4.15546 13.2274 4.15546 13.0021C4.15546 12.7769 3.97001 12.5944 3.74125 12.5944Z"
            fill="currentColor"
            className="primary"
        />
        <path
            d="M3.74125 17.2145H0.41421C0.185448 17.2145 0 17.3971 0 17.6223C0 17.8475 0.185448 18.0301 0.41421 18.0301H3.74125C3.97001 18.0301 4.15546 17.8475 4.15546 17.6223C4.15546 17.3971 3.97001 17.2145 3.74125 17.2145Z"
            fill="currentColor"
            className="primary"
        />
    </svg>
);

export default withCustomIcon(ContactIcon);